import { render, staticRenderFns } from "./dg-youtube-playlist.vue?vue&type=template&id=56fc6f98&scoped=true&"
import script from "./dg-youtube-playlist.vue?vue&type=script&lang=js&"
export * from "./dg-youtube-playlist.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=56fc6f98&scoped=true&lang=css&"
import style1 from "./dg-youtube-playlist.vue?vue&type=style&index=1&id=56fc6f98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fc6f98",
  null
  
)

export default component.exports